export function toNumberIfNumeric (value: string | number): string | number {
  return isNaN(Number(value)) || value === '' ? value : Number(value)
}
